import { render, staticRenderFns } from "./upgrade.vue?vue&type=template&id=ef4a71b6&scoped=true&"
import script from "./upgrade.vue?vue&type=script&lang=js&"
export * from "./upgrade.vue?vue&type=script&lang=js&"
import style0 from "./upgrade.vue?vue&type=style&index=0&id=ef4a71b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef4a71b6",
  null
  
)

export default component.exports